import { Component, ErrorInfo, ReactNode } from "react";
import { Link } from 'react-router-dom';
import { Button, Stack, Box } from '@chakra-ui/react';
import logo from './assets/Logo_EssilorLuxottica_black.png'
import './pages/Login/LoginPage.css'

type ErrorBoundaryProps = {
    children: ReactNode;
};

type ErrorBoundaryState = {
    hasError: boolean;
    error: Error | null;
};

class ErrorBoundary extends Component<ErrorBoundaryProps, ErrorBoundaryState> {
    constructor(props: ErrorBoundaryProps) {
        super(props);
        this.state = { hasError: false, error: null };
    }

    static getDerivedStateFromError(error: Error): ErrorBoundaryState {
        return { hasError: true, error };
    }

    componentDidCatch(error: Error, errorInfo: ErrorInfo): void {
        console.error("Error Boundary Caught an Error:", error, errorInfo);
    }

    render() {
        if (this.state.hasError) {
      


            return (
                <Box className="login-container">
                    <Box className="login-box">
                        <Stack spacing={4} align="center">
                            <img className="logo" src={logo} alt="Logo" style={{ width: '550px', height: 'auto' }} />
                            <h1><b>Something went wrong.</b></h1>
                            <h3>This error will be reported.</h3>
                            <Button as={Link} to="/" colorScheme="blue">
                                Go back home
                            </Button>
                        </Stack>
                    </Box>
                </Box>
            );
        }

        return this.props.children;
    }
}

export default ErrorBoundary;